import { styled } from '@mui/material/styles';
import MuiAutocomplete from '@mui/material/Autocomplete';

export const Autocomplete = styled(MuiAutocomplete)(({ theme }) => ({
    '& + .MuiAutocomplete-popper': {
        '& .MuiAutocomplete-listbox': {
            borderRadius: theme.spacing(1),
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
            padding: theme.spacing(1),
            backgroundColor: theme.palette.primary.main + '4D', // 30% transparency
        },
        '& .MuiAutocomplete-groupLabel': {
            letterSpacing: 1.5,
            fontSize: 12,
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontStyle: 'italic',
            padding: '4px 8px',
            lineHeight: '16px',
            margin: '8px 0',
        },
        '&  .MuiAutocomplete-option': {
            fontWeight: 700,
            fontSize: 14,
        },
    },
    '& .MuiAutocomplete-inputRoot': {
        borderColor: theme.palette.primary.main, // Primary color for border
    },
    '& .MuiAutocomplete-input': {
        padding: 0,
        maxWidth: '100%',
    },
    '& .MuiChip-root': {
        height: 24,
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.primary.main + '4D', // 30% transparency
        borderColor: theme.palette.primary.main, // Primary color for border
        borderWidth: 1,
        borderStyle: 'solid',
        '& .MuiChip-deleteIcon': {
            color: theme.palette.mode === 'dark'
                ? theme.palette.common.white
                : theme.palette.primary.main,
            fontSize: 14,
        },
        '& .MuiChip-label': {
            color: theme.palette.mode === 'dark'
                ? theme.palette.common.white
                : theme.palette.primary.main,
            fontSize: 12,
        },
    },
}));

